import { FunctionComponent } from "react";
import NAV from "../components/NAV";

const Lesson47: FunctionComponent = () => {
  return (
    <div className="relative [background:linear-gradient(111.77deg,_rgba(0,_0,_0,_0),_#363636_78.54%),_#0d0d0d] w-full overflow-hidden flex flex-col items-center justify-center pt-[2.69rem] px-[2.69rem] pb-[7.63rem] box-border gap-[6.88rem] text-left text-[1.56rem] text-darkgray font-nunito">
      <NAV dimensionCode="/nav@2x.png" navIconFlexShrink="unset" />
      <div className="self-stretch flex flex-row items-center justify-between">
      <a className="cursor-pointer text-darkgray no-underline" href={"/lesson46"}>
        <div className="flex-1 rounded-32xl bg-gainsboro-200 box-border h-[3.5rem] flex flex-col items-center justify-center py-[0.69rem] px-[3rem] max-w-[12.5rem] border-[1px] border-solid border-gray-300">
          <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
            Back
          </b>
        </div>
        </a>
        <div className="self-stretch flex-1 flex flex-col items-center justify-center text-center text-[2.81rem] text-white">
          <b className="self-stretch relative leading-[100%]">
            Weakly Meal Plans
          </b>
        </div>
        <a className="cursor-pointer text-darkgray no-underline" href={"/lesson48"}>
        <div className="flex-1 rounded-32xl bg-gainsboro-200 box-border h-[3.5rem] flex flex-col items-center justify-center py-[0.69rem] px-[3rem] max-w-[12.5rem] border-[1px] border-solid border-gray-300">
          <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
            Next
          </b>
        </div>
        </a>
      </div>
      <div className="w-full flex flex-col items-center justify-center gap-[9.63rem] max-w-[125rem] text-[1.88rem] text-white font-dm-sans">
        <div className="self-stretch flex flex-row items-center justify-center">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <b>
                <span>What are Weekly Meal Plans?</span>
              </b>
            </p>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  Weekly meal plans are a way to plan out your meals for the
                  week in advance. This can help you save time and money, and it
                  can also help you eat healthier.
                </span>
              </span>
            </p>
          </div>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-justify text-[1.56rem]">
          <p className="m-0 text-[1.88rem]">
            <b>
              <span>How Many Meals Per Day?</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                It is evident that we generally recommend dividing your protein
                intake among multiple meals throughout the day to maximize the
                anabolic potential of each meal. Optimal protein distribution
                involves spreading protein consumption more evenly rather than
                concentrating it in one or two large meals. While reaching your
                total daily protein target is crucial, it may not be sufficient
                to maximize results. Theoretically, since there is a maximum
                threshold for stimulating muscle protein synthesis (MPS) in a
                single feeding, increasing the frequency of meals (up to a
                certain point) should enhance muscle-building capabilities. Now,
                let's explore what scientific research has to say about this.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                A group of researchers conducted a study comparing the effects
                of splitting a high-protein diet into three meals per day versus
                six meals per day on body composition. The study involved
                subjects following a caloric maintenance phase for 28 days and
                then a 25 percent caloric deficit phase for another 28 days.
                Here's how the groups were structured:
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  Group 1 - Traditional (low protein) diet: 3 meals per day,
                  macronutrient ratio: ~24% fat/61% carbs/16% protein
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  Group 2 - High protein diet: 3 meals per day, macronutrient
                  ratio: ~22% fat/45% carbs/34% protein
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  Group 3 - High protein diet: 6 meals per day, macronutrient
                  ratio: ~22% fat/45% carbs/33% protein
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                During the initial 28-day period at caloric maintenance, both
                high protein groups achieved body recomposition, and during the
                25 percent caloric deficit phase, all groups experienced weight
                loss. However, Group 3, which consumed six protein-containing
                meals per day, showed the greatest reduction in body fat
                percentage (2.8 percent), specifically abdominal fat, and was
                the only group that gained lean body mass throughout the study
                (1.32 pounds)!
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                This outcome could be attributed, at least in part, to the
                subjects stimulating muscle protein synthesis six times a day
                compared to only three times per day. It's important to note
                that the participants in this study were overweight or obese
                individuals and not highly trained athletes.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                This study had excellent control measures, providing a seven-day
                menu plan to all participants for the entire 62-day
                intervention, unlike many other studies that rely on dietary
                recall, which can introduce errors and lack validity .
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Based on this evidence, we consider this study supportive of the
                idea that consuming more than three protein-containing meals per
                day may have a more anabolic effect compared to consuming three
                or fewer meals per day.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch flex flex-row items-center justify-center text-[1.56rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0 text-[1.88rem]">
              <b>
                <span>How to Create Weekly Meal Plans</span>
              </b>
            </p>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>To create weekly meal plans, you will need to:</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <ul className="m-0 pl-[2.06rem]">
              <li className="mb-[0rem]">
                <span>
                  <span>Decide how many meals you want to eat per day.</span>
                </span>
              </li>
            </ul>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <ul className="m-0 pl-[2.06rem]">
              <li className="mb-[0rem]">
                <span>
                  <span>Decide what type of meals you want to eat.</span>
                </span>
              </li>
            </ul>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <ul className="m-0 pl-[2.06rem]">
              <li className="mb-[0rem]">
                <span>
                  <span>Make a list of the ingredients you need.</span>
                </span>
              </li>
            </ul>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <ul className="m-0 pl-[2.06rem]">
              <li className="mb-[0rem]">
                <span>
                  <span>Shop for the ingredients.</span>
                </span>
              </li>
            </ul>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <ul className="m-0 pl-[2.06rem]">
              <li>
                <span>
                  <span>Cook the meals.</span>
                </span>
              </li>
            </ul>
          </div>
        </div>
        <div className="self-stretch flex flex-row items-center justify-center">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <b>
                <span>Examples of Diverse Weekly Meal Plans For Bulking</span>
              </b>
            </p>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  <span>
                    Here are some examples of a diverse weekly meal plans:
                  </span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <b>Monday:</b>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>Breakfast - Oats with fruit</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>{`Lunch - Grilled chicken with fonio, pasta, potato or rice + roasted vegetables (broccoli, peppers, onions & tomato's)`}</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>Dinner - Salmon with roasted vegetables</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <b>Tuesday:</b>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>Breakfast - Yogurt with granola</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>{`Lunch - Grilled chicken with fonio, pasta, potato or rice + roasted vegetables (broccoli, peppers, onions & tomato's)`}</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>Dinner - Steak with roasted vegetables</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <b>Wednesday:</b>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>Breakfast - Eggs with toas</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>Lunch - Leftover stir-fry</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>Dinner - Pasta with marinara sauce</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <b>Thursday:</b>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>Breakfast - Smoothie</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>Lunch - Salad with tuna</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>Dinner - Chicken breast with roasted potatoes</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <b>{`Friday: `}</b>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>Breakfast - Pancakes with fruit</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>Lunch - Out to eat</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>Dinner - Pizza night!</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>
                    We will later inform you on how to calculate calories in
                    order to eat only how much you need.
                  </span>
                </span>
              </span>
            </p>
          </div>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-justify">
          <p className="m-0">
            <b>
              <span>Examples of Fixed Weekly Meal Plans</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                <span>
                  Here are some examples of a diverse weekly meal plans:
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b>Monday:</b>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>Breakfast - Salad with grilled chicken</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>Lunch - Salad with grilled chicken</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>Dinner - Salmon with roasted vegetables</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b>Tuesday:</b>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>{`Breakfast - Oatmeal with fruit / fast & skip breakfast`}</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>Lunch - Sandwich on whole-wheat bread</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>Dinner - Stir-fry with tofu</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b>Wednesday:</b>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>{`Breakfast - Oatmeal with fruit / fast & skip breakfast`}</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>Lunch - Leftover stir-fry</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>Dinner - Pasta with marinara sauce</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b>Thursday:</b>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>{`Breakfast - Oatmeal with fruit / fast & skip breakfast`}</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>Lunch - Salad with tuna</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>Dinner - Chicken breast with roasted potatoes</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b>{`Friday: `}</b>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>Breakfast - Pancakes with fruit</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>Lunch - Out to eat</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>Dinner - Pizza night!</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  We will later inform you on how to calculate calories in order
                  to eat only how much you need.
                </span>
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-justify text-[1.56rem]">
          <p className="m-0 text-[1.88rem]">
            <b>
              <span>Tips for Creating Weekly Meal Plans</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>Here are some tips for creating weekly meal plans:</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>Be realistic about your time and budget.</span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>Don't be afraid to get creative.</span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>Make sure your meals are balanced and nutritious.</span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>Have fun with it!</span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                By following these tips, you can create weekly meal plans that
                will help you eat healthier and save time and money.
              </span>
            </span>
          </p>
        </div>
        <a className="cursor-pointer text-darkgray no-underline" href={"/lesson48"}>
        <div className="rounded-32xl bg-gainsboro-200 box-border w-[25rem] flex flex-col items-center justify-center pt-[0.69rem] px-[3rem] pb-[1rem] max-w-[31.25rem] text-center text-[1.88rem] border-[1px] border-solid border-gray-300">
          <b className="self-stretch relative">Next Chapter</b>
        </div>
      </a>
      </div>
    </div>
  );
};

export default Lesson47;
